"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.compileConstruction = void 0;
const anchor_1 = require("@project-serum/anchor");
const __1 = require("..");
const tokens_1 = require("../utils/tokens");
const actions_1 = require("./actions");
const construciton_1 = require("./construciton");
const spl_token_1 = require("@solana/spl-token");
const cleanup_1 = require("./cleanup");
const compileConstruction = (provider, mallocProgram, { construction, amountInAccounts, actionMap, opts }) => __awaiter(void 0, void 0, void 0, function* () {
    const { actions, initialSplits, initialActionIndices, amountIns } = construction;
    const _inAuth = opts === null || opts === void 0 ? void 0 : opts.amountInAuthority;
    let amountInAuthority = _inAuth !== null && _inAuth !== void 0 ? _inAuth : provider.wallet;
    const _authority = opts === null || opts === void 0 ? void 0 : opts.authority;
    let authority = _authority || provider.wallet;
    const { accounts: tokenAccounts, txs: tokenTxs } = yield (0, tokens_1.createTokenAccountsForActions)(provider, authority, actions, provider.wallet, opts === null || opts === void 0 ? void 0 : opts.preferredTokenAccounts);
    let constructionTx;
    let constructionSigner;
    if (!(opts === null || opts === void 0 ? void 0 : opts.constructionAccount)) {
        const ret = yield (0, construciton_1.createAndInitConstruction)(mallocProgram, authority.publicKey, actions.length);
        constructionTx = ret.tx;
        constructionSigner = ret.construction;
    }
    else {
        constructionSigner = opts.constructionAccount;
    }
    const addConstructionActionsTx = (0, actions_1.addActionsToConstruction)(mallocProgram, constructionSigner.publicKey, actions, authority);
    if (!(0, tokens_1.checkInMintsAreTheSame)(initialActionIndices.map((i) => actions[i]))) {
        throw __1.errors.newCompilerError("Expected all initial token types to be the same");
    }
    if (initialActionIndices.length === 0)
        throw __1.errors.newCompilerError("Expected initial actions to have length more than 0");
    // TODO: check all token mints for init actions are the same
    const initMints = actions[initialActionIndices[0]].tokenMintsIn;
    if (initMints.length !== amountIns.length) {
        throw __1.errors.newCompilerError("Expected number of initial amounts to equal number of initial mints");
    }
    if (amountInAccounts.length !== amountIns.length) {
        throw __1.errors.newCompilerError("Expected the number of initial accounts to equal the number of amounts in");
    }
    // TODO: have this transfer transaction be conditional,
    // See https://github.com/Lev-Stambler/malloc-solana2/issues/4
    const transferTxs = yield Promise.all(amountIns.map((amount, i) => (0, tokens_1.transferToTx)(amountInAccounts[i], tokenAccounts[initMints[i].toBase58()].publicKey, new anchor_1.BN(amount), amountInAuthority)));
    const prepareConstructionTx = (0, construciton_1.prepareConstruction)(mallocProgram, constructionSigner.publicKey, initialActionIndices, initialSplits, authority, amountIns);
    // The additional accounts added onto action action accounts follow conventional malloc standards for token
    const actionCtxFilled = actions.map((action, i) => {
        var _a;
        const toAdd = ((_a = action.opts) === null || _a === void 0 ? void 0 : _a.addDefaultTokAccounts)
            ? [
                {
                    address: tokenAccounts[action.tokenMintsIn[0].toBase58()].publicKey,
                    isWriteable: true,
                    isSigner: false,
                },
                {
                    address: spl_token_1.TOKEN_PROGRAM_ID,
                    isWriteable: false,
                    isSigner: false,
                },
                {
                    address: authority.publicKey,
                    isSigner: true,
                    isWriteable: false,
                },
            ]
            : [];
        return {
            ctx: {
                actionProgram: action.actionProgram,
                owner: authority.publicKey,
            },
            actionAccounts: [...toAdd, ...action.actionAccounts],
        };
    });
    const processActionsTxs = construction.actionOrders.map((actionsInTx) => (0, actions_1.getProcessActionsTx)(mallocProgram, actionsInTx, constructionSigner.publicKey, actionsInTx.map((idx) => actionCtxFilled[idx]), authority, actionsInTx.map((idx) => {
        var _a, _b, _c;
        return {
            data: actions[idx].actionData,
            instructions: (_a = actions[idx].opts) === null || _a === void 0 ? void 0 : _a.instructions,
            additionalSigners: (_b = actions[idx].opts) === null || _b === void 0 ? void 0 : _b.additionalSigners,
            preActionTxs: (_c = actions[idx].opts) === null || _c === void 0 ? void 0 : _c.preActionTxs,
        };
    })));
    const actionPIDToUID = getActionPIDToUID(actions, actionMap);
    const atStartOfPrepareTxs = getAllAtStartOfPrepareTxs(actions);
    // const resultAccounts = Object.keys(initResultAccounts).reduce((prev, pid) => {
    //   prev[pid] = initResultAccounts[pid].resultAccount;
    //   return prev;
    // }, {});
    const cleanUpTxs = (opts === null || opts === void 0 ? void 0 : opts.cleanupAtEnd)
        ? yield (0, cleanup_1.cleanup)(provider, mallocProgram, construction, 
        // resultAccounts,
        constructionSigner, authority, opts === null || opts === void 0 ? void 0 : opts.cleanupOpts)
        : [];
    const txs = [
        { type: "prepended", txs: atStartOfPrepareTxs },
        { type: "token", txs: tokenTxs },
        { type: "transfer", txs: transferTxs },
        { type: "construction", txs: constructionTx ? [constructionTx] : [] },
        { type: "add construction actions", txs: addConstructionActionsTx },
        { type: "prepare construction", txs: prepareConstructionTx },
        // {
        //   type: "init result accounts",
        //   txs: Object.values(initResultAccounts)
        //     .map((r) => r.tx ?? null)
        //     .filter((tx) => tx !== null),
        // },
        {
            type: "action calls",
            txs: processActionsTxs,
        },
        {
            type: "cleanup",
            txs: cleanUpTxs,
        },
    ];
    return {
        constructionSigner,
        construction,
        txs,
        tokenAccounts,
        authority,
        // resultAccounts,
        actionMap,
        actionPIDToUID,
    };
});
exports.compileConstruction = compileConstruction;
const getActionPIDToUID = (actions, actionMap) => {
    const ret = {};
    actions.forEach((action) => {
        ret[action.actionProgram.toBase58()] = action.actionTypeUID;
    });
    return ret;
};
const getAllAtStartOfPrepareTxs = (actions) => actions.map((a) => { var _a; return ((_a = a.opts) === null || _a === void 0 ? void 0 : _a.atStartOfPrepareTxs) || []; }).flat();
